import { render, staticRenderFns } from "./Passes.vue?vue&type=template&id=7d34d674&scoped=true"
import script from "./Passes.vue?vue&type=script&setup=true&lang=ts"
export * from "./Passes.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Passes.vue?vue&type=style&index=0&id=7d34d674&prod&scoped=true&lang=css"
import style1 from "./Passes.vue?vue&type=style&index=1&id=7d34d674&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d34d674",
  null
  
)

export default component.exports